import { NgxSummernoteDirective } from 'ngx-summernote';


export function getDefaultSummernoteOptions() //:Summernote.Options
{
  return {
    toolbar: [
      ['font', ['fontname', 'fontsize', 'bold', 'italic', 'underline', 'strikethrough', 'forecolor', 'backcolor', 'superscript', 'subscript', 'clear']],
      ['para', ['ol', 'ul', 'paragraph']],
      ['insert', ['table', 'link', 'picture']],
      ['misc', ['codeview', 'undo', 'redo',]]
    ],
    fontNames: ['Calibri', 'Arial', 'Verdana', 'Times New Roman'],
    dialogsInBody: true,
    height: '100%',
    disableResizeEditor: true,
    popover: {
      table: [
        ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
        ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
      ],
      image: [
        ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
        ['float', ['floatLeft', 'floatRight', 'floatNone']],
        ['remove', ['removeMedia']],
      ],
      link: [['link', ['linkDialogShow', 'unlink']]],
      air: [
        [
          'font',
          [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'superscript',
            'subscript',
            'clear',
          ],
        ],
      ],
    },
  }
}

export function inserTextInline(note: NgxSummernoteDirective, text: string) {
  const summernote = (note as any)._$element;
  if (summernote != null && 'summernote' in summernote) {
    console.log(`insert fields: ${text}`);
    summernote.summernote('editor.restoreRange');
    summernote.summernote('editor.focus');
    summernote.summernote('editor.insertText', text);
  } else {
    throw new Error(`No SummerNote found`);
  }
}

